<template>
  <v-layout>
    <div v-if="loading">
      <spinner />
    </div>
    <v-layout v-else column>
      <v-flex>
        <select-field
          v-if="isFloorPlan"
          v-model="form.ticketType"
          :items="ticketTypes"
          label="Ticket type"
        />
      </v-flex>
      <v-flex class="pb-16">
        <text-field
          v-model.trim="form.name"
          autofocus
          :validator="vs.form.name"
          label="Ticket name*"
        />
      </v-flex>
      <v-layout class="pb-8">
        <text-field
          v-model.trim="form.price"
          type="number"
          step="0.01"
          :suffix="currency"
          :onwheel="true"
          :validator="vs.form.price"
          disabled
          label="Price*"
        />
      </v-layout>
      <v-flex class="pb-16">
        <text-field
          v-model.number="form.initialQuantity"
          type="number"
          :validator="vs.form.initialQuantity"
          label="Initial quantity*"
          :onwheel="true"
          :error-messages="{
            maxValue:
              maxInitialQuantity === 0
                ? 'You cannot add any new tickets because total tickets number already exceeded event capacity.'
                : `Total quantity exceeds event capacity. You can set the quantity to a maximum of ${maxInitialQuantity}.`,
            minValue: 'Quantity must be higher than 0.',
          }"
        />
      </v-flex>
      <v-flex class="pb-16">
        <textarea-field
          v-model.trim="form.description"
          :validator="vs.form.description"
          label="Ticket description"
        />
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  name: 'gratis-ticket-form',
  props: {
    initialValues: {
      type: Object,
      default: null,
    },
    vs: {
      type: Object,
      default: () => ({}),
    },
    currency: {
      default: null,
      type: String,
    },
    isFloorPlan: {
      default: false,
      type: Boolean,
    },
    maxInitialQuantity: null,
    hasParterTickets: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      form: this.initialValues || {},
      loading: true,
      ticketTypes: this.hasParterTickets ? ['Parter ticket', 'Floor Plan'] : ['Floor Plan'],
    }
  },
  mounted() {
    this.loading = false
    if (this.ticketTypes.length === 1) {
      this.form.ticketType = this.ticketTypes[0]
    }
  },
}
</script>

<style scoped>
@media (max-width: 800px) {
  .pb-8 {
    margin-bottom: 1rem;
  }
}
</style>
